export default "__VITE_ASSET__40d4fbad__"